export const redColor = '#8e0a5b';
export const blueColor = '#5464c1';
export const redBlueBlendColor = '#71378E';
export const lightBodyColor = '#edeef2ff';
export const darkBodyColor = '#1e1e2f';
export default null;
